import axios from 'axios';

export const getAuthCentralToken = async () => {
    const username = process.env.REACT_APP_CENTRAL_USER;
    const password = process.env.REACT_APP_CENTRAL_PASSWORD;

    const res = await fetch('https://dev-central-gpsi.visage.golf/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    });

    if (!res.ok) throw new Error('wrong credentials');

    const { token } = await res.json();
    localStorage.setItem('jwt', token);

    return token;
};

axios.interceptors.request.use(async (config) => {
    let token = localStorage.getItem('jwt');
    let tokenCreated = localStorage.getItem('created_jwt');

    const sixtyMinutes = 60 * 60 * 1000;

    const shouldRefresh = !token || !tokenCreated || (Date.now() - Number(tokenCreated)) > sixtyMinutes;

    if (shouldRefresh) {
        token = await getAuthCentralToken();

        localStorage.setItem('created_jwt', Date.now().toString());
    }

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

export const getAllDevicesBySite = async (siteId) => {
    let baseUrl = "https://dev-central-gpsi.visage.golf";

    if (process.env.REACT_APP_API_URL.includes("prod")) {
        baseUrl = "https://central-gpsi.visage.golf";
    }

    const response = await axios.get(
        `${baseUrl}/DeviceConfig/GetAllDevicesByTargetServerAndTargetSite/QC/${siteId}`
    );

    return response.data;
};